import React, { useState } from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import ChatIcon from '@mui/icons-material/Chat'
import CloseIcon from '@mui/icons-material/Close'
import ChatDialog from './ChatDialog'
import './chatbox.scss'

export default function ChatBox() {
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      {/* Botón flotante con icono de chat */}
      <Box className="chatbox-button">
        <Tooltip title="Chatbot de Ingeniosoft">
          <IconButton
            onClick={handleOpen}
            className="chatbox-icon"
            size="large"
            aria-label="Abrir chat"
          >
            <ChatIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Diálogo del chat */}
      <ChatDialog open={open} onClose={handleClose} />
    </>
  )
}
